module.exports = __webpack_public_path__ + "img/addigy_logo.9b54df10.svg";